// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3ocd8","unreadBadge":"styles_unreadBadge__IYXAs","modalContent":"styles_modalContent__23aNw","modal":"styles_modal__3AS5-"};